import React from 'react'

import { IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

interface CommercialOnlyProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const CommercialOnly: React.FC<CommercialOnlyProps> = ({
  children,
  fallback = null,
}) => <>{IS_FEDRAMP_ENVIRONMENT ? fallback : children}</>
